import React from 'react';
import { VideoPopupWhatsappServices } from './VideoPopupWhatsappServices';

export const WhatsappServicesVideoBlogs = () => {
    return (
        <>
            <div className="container-fluid py-lg-5"
                // style={{ backgroundColor: '#d8d8d8ff' }}
                // style={{ backgroundImage: 'linear-gradient(to right, #d8d8d8, #f0f0f0)' }}
                style={{ backgroundImage: 'linear-gradient(to right, #d8d8d8, #b0c4de)' }}
            // style={{ backgroundImage: 'linear-gradient(135deg, #e0e0e0, #cfcfcf, #a9a9a9)' }}
            >
                <div className='row'>
                    <div className="col-12 col-md-10 mx-auto py-1 mb-lg-3">
                        <h3 className="fw-bold colorcharchol text-center">Video Blogs</h3>

                        <div className="zoom-in-out-box2 m-auto">
                            <hr />
                        </div>
                    </div>
                    <div className='col-12 '>
                        <div id="" className="">

                            <div className="row mb-lg-3" >
                                {/* <div className="col-4 cursor-pointer">
                                    <div className=" justify-content-center align-items-center">
                                        <video width="100%" height="300px" poster="Assets/Images/video/review2.png" controls>
                                            <source src="Assets/Images/video/blackSpotVideo1.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div>

                                <div className="col-4 cursor-pointer">
                                    <div className=" justify-content-center align-items-center">
                                        <video width="100%" height="300px" poster="Assets/Images/video/review3.png" controls>
                                            <source src="Assets/Images/video/blackSpotVideo2.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div> */}

                                {/* <div className="col-4 cursor-pointer">
                                    <div className=" justify-content-center align-items-center">
                                        <video width="100%" height="300px" poster="Assets/Images/video/review1.png" controls>
                                            <source src="Assets/Images/video/RTOThaneBlackSpotVideo.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                                </div> */}
                                <VideoPopupWhatsappServices />
                                {/* <span className='text-center'>Hon</span>      */}
                                {/* <div className='d-none d-lg-block '>
                                    <footer className="blockquote-footer bg-light  text-center "
                                        style={{ marginTop: '8px', fontSize: '16px', width: '400px', }}
                                    >
                                        <b className="text-dark">Hon. Rohit Alka Raosaheb Katkar</b> <br />
                                        <cite title="Source Title" style={{ fontSize: '15px' }}>
                                            Sub-regional transport officer
                                        </cite>
                                    </footer>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className='col-12 text-center mx-auto py-3 '>
                        <h4 className="fw-bold colorcharchol text-center ">Citizens Appreciate RTO Thane’s New WhatsApp Alert Service</h4>
                        <div className="zoom-in-out-box2 m-auto mb-3">
                            <hr />
                        </div>
                        <p>
                            Users have praised the new WhatsApp alert service by RTO Thane for making communication faster and more convenient. They find the instant reminders about renewals and compliance updates very helpful in avoiding penalties and missed deadlines. Many also appreciate the transparency and efficiency brought by the dynamic web dashboard, which ensures better monitoring and reliable service delivery. Overall, the initiative is seen as a smart step toward a more citizen-friendly and digital RTO experience.
                        </p>
                    </div>
                </div>

            </div>
        </>
    );
};
